import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MUIAlert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import React from 'react';
import {styled} from '@mui/material/styles';

export const NOTIFICATION_TYPES = {
  snackbar: 'snackbar',
  miniDialog: 'miniDialog',
};

const Alert = styled(MUIAlert)(({theme}) => ({
  borderRadius: 10,
  '& .MuiAlert-message': {
    ...theme.typography.body1,
  },
}));

export const AlertSnackbar = ({
  progress,
  closeButton = true,
  closeToast,
  title = '',
  message,
  actions,
  severity = 'info',
  ...props
}) => {
  return (
    <Alert
      icon={false}
      elevation={2}
      variant="filled"
      onClose={!progress && closeButton ? closeToast : undefined}
      action={actions}
      color={severity === 'info' ? 'primary' : null}
      severity={severity}
      {...props}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      <Box display="flex" alignItems="center">
        {progress && (
          <CircularProgress
            color="inherit"
            size={22}
            style={{marginRight: 16}}
          />
        )}
        {message}
      </Box>
    </Alert>
  );
};

AlertSnackbar.propTypes = {
  actions: PropTypes.array,
  message: PropTypes.node,
  closeToast: PropTypes.func,
  title: PropTypes.string,
  severity: PropTypes.string,
  progress: PropTypes.bool,
  closeButton: PropTypes.bool,
};

export default AlertSnackbar;
